module.exports = __webpack_public_path__ + "img/server-error.9bdab6f.svg";